<template>
  <div class="company" :class="{ showDetail: $route.path !== '/news/company' }">
    <div v-show="$route.path == '/news/company'">
      <h1 class="title">企业新闻</h1>
      <p class="sub-title">CORPORATE NEWS</p>
      <div class="wrap">
        <div
          class="news"
          v-for="(item, index) in datas.data"
          :key="index"
          @click="
            $router.push({
              path: '/news/company/detail',
              query: { id: item.id },
            })
          "
        >
          <img :src="item.image" alt srcset />
          <div>
            <p class="name">{{ item.name }}</p>
            <p class="date">{{ item.date }}</p>
            <p class="desc">{{ spliceText(item.summary, 28) }}</p>
          </div>
        </div>
      </div>
      <el-pagination
        :page-size="6"
        background
        layout="prev, pager, next"
        :total="datas.total"
        @current-change="change"
      ></el-pagination>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { article } from '../../assets/js/api'
export default {
  data() {
    return {
      datas: {},
      page: 1,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    change(e) {
      this.page = e
      this.getData()
    },
    getData() {
      article({
        limit: 6,
        page: this.page,
        where: {
          type: 1,
        },
      }).then((r) => {
        this.datas = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.company {
  padding: 90px 0;
}

.company.showDetail {
  background-color: #f3f2f2;
}

h1.title {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  text-align: center;
}

p.sub-title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  text-align: center;
}

.wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 50px;
  width: 1200px;

  .news {
    width: 595px;
    height: 220px;
    display: flex;
    cursor: pointer;
    margin-bottom: 10px;

    img {
      width: 280px;
      height: 100%;
      object-fit: cover;
    }

    div {
      width: calc(100% - 280px);
      height: 100%;
      padding: 30px 20px;
      box-sizing: border-box;
      background: #e7e6eb;
      transition: all 0.15s linear;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      & > * {
        transition: all 0.15s linear;
      }

      .name {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        // text-overflow: ellipsis;
        // overflow: hidden;
        // white-space: nowrap;
      }

      .date {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        // margin-bottom: 50px;
      }

      .desc {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        word-break: break-all;
      }
    }
  }

  .news:hover {
    div {
      background: #0e6cb6;
    }

    .name,
    .desc,
    .date {
      color: white;
    }

    .date {
      opacity: 0.8;
    }
  }
}
</style>
